import { render, staticRenderFns } from "./DetalleGaleriaView.vue?vue&type=template&id=459a7c10&"
import script from "./DetalleGaleriaView.vue?vue&type=script&lang=ts&"
export * from "./DetalleGaleriaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports